<div class="marketplace-transfer-success-page mt-5">
  @if (transferDetails?.purchasedItem) {
    <div class="container">
      <div class="card rounded">
        <div class="card-header">
          <h6 class="text-success fw-bold mb-0">{{ 'marketplace.transfer.success.title' | translate }}</h6>
        </div>
        <div class="card-body">
          <p class="marketplace-transfer-message">
            {{ 'marketplace.transfer.success.message' | translate }}
          </p>
          <div class="transferred-item-details">
            <div class="img-wrapper">
              <img [src]="transferDetails?.purchasedItem?.Image | contentImage: '7'" alt="" />
            </div>
            <div class="transferred-item-details-container mt-1">
              <div class="transferred-item-name mb-3 font-size-14 fw-bold">{{ transferDetails?.purchasedItem?.Name }}</div>
              <div class="transferred-item-qty d-flex align-items-center">
                <div class="lbl">{{ 'marketplace.transfer.success.qty.label' | translate }}</div>
                <label class="font-size-14">{{ transferDetails?.qty }}</label>
              </div>
              <div class="transferred-item-recipient d-flex align-items-center">
                <div class="lbl">{{ 'marketplace.transfer.success.transfer.to' | translate }}</div>
                <label class="font-size-14">{{ transferDetails?.transferredTo?.Email }}</label>
              </div>
            </div>
          </div>
          <div class="action-wrapper mt-4">
            <button class="btn btn-primary fw-bold" [routerLink]="['/rewards/wallet']">
              {{ 'marketplace.transfer.success.page.back' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
